import { isError } from 'flux-standard-action';
import { normalize } from 'normalizr';
import defaultsDeep from 'lodash/defaultsDeep';
import { vodContent as vodContentSchemas } from 'app-webtech-core/schemas';
import { metaExtractor, payloadExtractor } from 'app-webtech-core/reducers/payloadExtractor';
import { updateState } from 'app-webtech-core/reducers/updateState';
import { VOD_CONTENT_STATE_STATUSES } from '../constants';

const { VodContentSchema } = vodContentSchemas;

const requestMutationGenerator = () => ({
  fetchBySlugStatus: { $set: VOD_CONTENT_STATE_STATUSES.PENDING },
  fetchBySlugError: { $set: null },
});

const successMutationGenerator = (vodContentData) => ({
  entities: (currentEntities) => {
    const { entities } = normalize([vodContentData], [VodContentSchema]);

    entities.vodContent = { ...entities.vodContent, ...entities.vodEpisodes };

    return defaultsDeep({}, currentEntities, entities);
  },
  fetchBySlugStatus: { $set: VOD_CONTENT_STATE_STATUSES.DONE },
  fetchBySlugError: { $set: null },
});

const errorMutationGenerator = (error) => ({
  fetchBySlugStatus: { $set: VOD_CONTENT_STATE_STATUSES.ERROR },
  fetchBySlugError: { $set: error },
});

export const vodContentFetchBySlugRequestReducer = (currentState, action) =>
  updateState(
    currentState,
    (isError(action) ? errorMutationGenerator : requestMutationGenerator)(
      payloadExtractor(action),
      metaExtractor(action),
    ),
  );

export const vodContentFetchBySlugSuccessReducer = (currentState, action) =>
  updateState(
    currentState,
    (isError(action) ? errorMutationGenerator : successMutationGenerator)(
      payloadExtractor(action),
      metaExtractor(action),
    ),
  );

export const vodContentFetchBySlugFailureReducer = (currentState, action) =>
  updateState(
    currentState,
    errorMutationGenerator(payloadExtractor(action), metaExtractor(action)),
  );
